import { getLocale, getProfileId } from 'lib/store';
import { apiClient } from 'services/api-client';
import {
  PersonalisedAIReport,
  PersonalisedAIReportResponse,
  PostQuestionnairePayload,
} from './type';
import { ReportQuestion } from '../../types';

export const getAIReports = async (args?: {
  page_number: number;
  page_size: number;
}) => {
  return (await apiClient.get('/ai_report_details', {
    params: {
      locale: getLocale(),
      profile_id: getProfileId(),
      os: 'web',
      page_number: args?.page_number || 1,
      page_size: args?.page_size || 10,
    },
  })) as PersonalisedAIReportResponse;
};

export const getAIReportDetails = async (token_id: string) => {
  return (await apiClient.get('/ai_report_details', {
    params: {
      locale: getLocale(),
      profile_id: getProfileId(),
      token_id,
      os: 'web',
    },
  })) as PersonalisedAIReport[];
};

export const getAIReportQuestionnaire = async (type: string, q_id?: string) => {
  return (await apiClient.get('/ai_report', {
    params: {
      locale: getLocale(),
      profile_id: getProfileId(),
      type,
      os: 'web',
      ...(q_id && { q_id }),
    },
  })) as ReportQuestion[];
};

export const postAIReportQuestionnaire = async (
  payload: PostQuestionnairePayload
) => {
  const { answer_id, ...restPayload } = payload;

  const data = payload?.answer_id ? payload : restPayload;

  return (await apiClient.post(
    `/ai_report?os=web&locale=${getLocale()}&profile_id=${getProfileId()}`,
    data
  )) as ReportQuestion;
};

export const deleteAIReport = async (token_id: string[]) => {
  return await apiClient.delete(
    `/ai_report_details?os=web&locale=${getLocale()}&profile_id=${getProfileId()}`,
    { data: { token_id } }
  );
};
